<template lang="pug">
div
  modal.active(
    :active='showModal'
    @close='$router.back()',
    title='Vincular documentos'
  )
    div(slot='modal-body')
      form.list-filters(@submit.prevent='onFilter')
        .columns.align-center
          .column.col-auto
            abbr {{ 'doc.numero' | tModel }}
            int.input-sm.form-input.input-search(v-model='q.numero_eq' :placeholder="'doc_publicacao.numero' | tModel")
          .column.col-auto
            abbr {{ 'doc.ano' | tModel }}
            year.input-sm.form-input.input-search(v-model='q.ano_eq' :placeholder="'doc_publicacao.ano' | tModel")
          .column.col-auto.tooltip.tooltip-left(:data-tooltip="$i18n.t('views.buttons.filter.label')")
            button.btn.btn-link.mt-2(type='submit')
              i.fa.fa-search.fa-lg
      load-manager(:status='status')
        list-manager(:status='status', :count='docsParaPublicar.length')
          table.table.table-striped.table-sm
            thead
              tr
                th.actions-col
                th {{ 'doc.numero' | tModel }}/{{ 'doc.ano' | tModel }}          
                th {{ 'doc.valor_total' | tModel }}
                th {{ 'doc.created_at' | tModel }}
                th.actions-col
            tbody
              tr(v-for="doc in docsParaPublicar")
                td
                  label.form-checkbox
                    input(type='checkbox' @change='onCheckedDoc' :checked='docIds.includes(doc.id)' :value='doc.id')
                    i.form-icon
                td {{ doc.numero }}/{{ doc.ano }}
                td {{ doc.valor_total | currency('R$ ') }}
                td {{ doc.created_at | date }}
                td.actions-col
                  a.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                    :data-tooltip="'views.buttons.print.label' | translate"
                    :href='doc.url'
                    target='_blank'
                  )
                    btn-icon(name='print')
    .columns.align-center(slot='modal-footer')
      .column.text-left
        div(v-if='pages > 1')
          btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='page--', @next-page='page++')
      .column-col-auto
        button.btn.btn-primary(
          :disabled='!docIds.length',
          :class='{ loading }'
          @click='onConfirm'
        )
          btn-content(name='confirm' label="Vincular")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      state: ['current', 'loading', 'status', 'docsParaPublicar', 'count'],
      actions: ['fetchAttachDoc', 'fetchDocsParaPublicar'],
    },
  },
  data() {
    return {
      docIds: [],
      showModal: true,
      pages: 0,
      q: {
        numero_eq: '',
        ano_eq: '',
      },
    }
  },
  computed: {
    queryParams() {
      return { q: this.q, page: this.page }
    },
    page: {
      get() {
        return Number(this.$route.query.page) || 1
      },
      set(page) {
        this.routerReplace({ ...this.$route.query, page })
      },
    },
  },
  methods: {
    goPage(page) {
      this.page = page
    },
    onCheckedDoc(e) {
      const docId = Number(e.target.value)
      if (e.target.checked) {
        this.docIds.push(docId)
      } else {
        const index = this.docIds.indexOf(docId)
        if (index > -1) {
          this.docIds.splice(index, 1)
        }
      }
    },
    onFilter() {
      this.routerReplace({ ...this.$route.query, page: 1, q: this.q })
    },
    async routerReplace(query) {
      try {
        await this.$router.replace({ name: this.$route.name, query })
        this.listar()
      } catch (e) {}
    },
    async listar() {
      const res = await this.fetchDocsParaPublicar(this.queryParams)
      this.$set(this, 'pages', res.pages)
    },
    async onConfirm() {
      try {
        const { id } = this.current
        await this.fetchAttachDoc({ id, params: { doc_ids: this.docIds } })
        this.$toaster.success('Vinculado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  created() {
    this.q = this.$route.query.q || this.q
    this.listar()
  },
}
</script>

<style lang="stylus" scoped>
.list-filters
  position sticky
  top: -20px
  background-color #fff
  z-index 10
  padding-bottom 5px
</style>
